<template>
  <div class="forget">
    <div
      class="forget__container"
      :style="{
        marginTop: isMobile ? '50px' : '100px',
      }"
    >
      <div class="forget__container__header">
        <div class="forget__container__header__icon">
          <svg-icon iconClass="logoShape" className="forget__container__header__icon--logo"></svg-icon>
          <svg-icon iconClass="logoText" className="forget__container__header__icon--text"></svg-icon>
        </div>
        <div class="forget__container__header__text">
          {{ $t('password_reset.title') }}
        </div>
      </div>
      <div class="forget__container__form">
        <input
          class="forget__container__form__input"
          type="text"
          name="email"
          v-model="email"
          :placeholder="$t('password_reset.email')"
        />
        <div class="flex justify-between items-center">
          <input
            type="text"
            name="verify_code"
            v-model="verify_code"
            :placeholder="$t('password_reset.verify_code')"
            class="forget__container__form__input code"
          />

          <div
            @click="sendVerifyCode"
            v-baidu-event-tracking="{ feature: '重置密码页操作', action: '获取验证码' }"
            style="width: 110px"
            class="forget__container__form__input sendCode"
          >
            {{ isClick ? $t('password_reset.sending_verify_code') : $t('password_reset.send_verify_code') }}
          </div>
        </div>
        <input
          class="forget__container__form__input"
          type="password"
          name="password"
          v-model="password"
          :placeholder="$t('password_reset.password')"
        />
        <input
          class="forget__container__form__input"
          type="password"
          name="password2"
          v-model="password2"
          :placeholder="$t('password_reset.password_again')"
        />
        <div
          class="forget__container__form__submit"
          v-baidu-event-tracking="{ feature: '重置密码页操作', action: '提交按钮' }"
          @click="resetPassword"
        >
          {{ $t('register.form.submit') }}
        </div>
        <div class="register__container__form__action flex items-center justify-center">
          <el-link
            :underline="false"
            v-baidu-event-tracking="{ feature: '重置密码页操作', action: '立即登录' }"
            @click="redirectToLogin"
            >{{ $t('register.form.login') }}</el-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ForgetPassword',
  data() {
    return {
      email: '',
      verify_code: '',
      password: '',
      password2: '',
      isClick: false,
    }
  },
  computed: {
    isMobile() {
      return this.$isMobile() || document.body.clientWidth < 640
    },
  },
  methods: {
    resetPassword() {
      if (!this.email || !this.verify_code || !this.password || !this.password2) {
        this.$message.error(this.$t('password_reset.warning.not_finished'))
        return
      }
      if (this.password !== this.password2) {
        this.$message.error(this.$t('password_reset.warning.password_not_same'))
        return
      }
      this.$api.call(
        'POST',
        '/password/reset',
        {
          email: this.email,
          verify_code: this.verify_code,
          password: this.password,
        },
        (response) => {
          console.log(response)
          const {
            data: { message, code },
          } = response
          if (code === 0) {
            this.$message.success('密码重置成功')
            this.$router.push('/login')
          }
        },
      )
    },
    sendVerifyCode() {
      if (!this.email) {
        this.$message.error(this.$t('password_reset.warning.email_needed'))
        return
      }
      this.isClick = true
      this.$api.call(
        'POST',
        '/password/send_verify_code',
        {
          email: this.email,
        },
        (response) => {
          const {
            data: { message, code },
          } = response
          if (code == 0) {
            this.$message.success(message)
          }
          this.isClick = false
        },
      )
    },
    redirectToLogin() {
      this.$router.push({
        name: 'login',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.forget {
  &__container {
    width: 400px;
    margin: 100px auto;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 45px;
      &__icon {
        &--logo {
          width: 31.6px !important;
          height: 24px !important;
          color: var(--bgGreen) !important;
        }
        &--text {
          width: 79.5px !important;
          height: 24px !important;
          margin-left: 5px;
          color: var(--logoColor) !important;
        }
      }
      &__text {
        font-size: 20px;
        font-weight: 600;
        color: var(--textBlack);
      }
    }
    &__form {
      &__input {
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 19px 20px;
        width: 100%;
        margin-bottom: 15px;
        background: var(--loginInputBg);
        color: var(--memoContentColor);
      }
      .code {
        width: 280px;
      }
      .sendCode {
        cursor: pointer;
        font-size: 12px;
        border: 1px solid var(--bgGreen);
        color: var(--bgGreen);
        &:hover {
          background: var(--hoverBg);
        }
      }
      &__submit {
        background: var(--bgGreen);
        border: 1px solid var(--loginBtnBorder);
        box-sizing: border-box;
        border-radius: 6px;
        padding: 16px 20px;
        color: var(--memberPlanColor);
        cursor: pointer;
        width: 100%;
        margin-bottom: 15px;
        text-align: center;
        &:hover {
          background: var(--yearPlanHoverBg);
        }
      }
      &__terms {
        margin-bottom: 15px;
        input {
          margin-right: 10px;
        }
        div {
          color: #9d9d9d;
          font-size: 14px;
          font-weight: 400;
          a {
            color: #9d9d9d;
          }
        }
      }
      &__action {
        margin-top: 30px;
      }
    }
  }
}
</style>
<style lang="scss">
.forget {
  &__container {
    &__form {
      .el-link.el-link--default {
        color: var(--tagColor);
        font-weight: unset;
      }
    }
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 600px) {
  .forget {
    &__container {
      width: 350px;
      &__form {
        .code {
          width: 230px;
        }
      }
    }
  }
}
</style>
